import CheckboxField from "../checkboxField/checkboxField";
//import { CheckboxFieldProps } from "../checkboxField/types/checkboxFieldProps";
import Label from "../shared/label/label";
import { labelProps } from "../shared/label/types/labelProps";
//import { Option } from "../shared/selectInput/types/selectInputProps";
import { CheckboxMultiFiedProps } from "./types/checkboxMultiFieldProps";
import './checkboxMultiField.scss'
import { styleFormField } from "../shared/stylization";
import { ReactComponent as ErrorIcon } from "../../icons/error.svg";
import { AdditionalIcon } from "../shared/additionalIcon/additionalIcon";

const CheckboxMultiField = (props: CheckboxMultiFiedProps) => {

    var labelProps: labelProps = {
        style: {
            marginBottom: '10px',
            display: "inline-block"
        }
    }

    const createCheckboxes = () => {
        return (<div className={props.className ? props.className : "multi-checkbox-field"} style={props.oneColumn ? { gridTemplateColumns: 'auto' } : undefined}>{props.checkboxOptions?.map((option, index) => {
            var selected = false;
            var disabled = false;
            if (props.selectedValues?.includes(option.value as never)) selected = true;
            if (props.disabledElementsIndex?.includes(index as never) || props.disableAllElements) disabled = true;
            return (<CheckboxField indexElement={props.indexElement} forMultiChange={props.onChange} key={option.name}
                checkmarkSmall={true} labelName={option.name} value={option.value} inputChecked={selected} disabled={disabled} />)
        })}</div>)
    }

    return (
        <div style={styleFormField}>
            <Label {...labelProps} className={props.labelClass ? props.labelClass : "body-txt-medium"} labelname={props.labelName} />
            {createCheckboxes()}
            {props.error &&
                <div className="errorCheckbox">
                    <p>{AdditionalIcon(ErrorIcon)}{props.errorMsg}</p>
                </div>
            }
        </div>
    )
}

export default CheckboxMultiField;